"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsSessionReporter = void 0;
var app_utils_1 = require("@sixfold/app-utils");
var nanoid_1 = require("nanoid");
var React = __importStar(require("react"));
var context_1 = require("./context");
var AnalyticsSessionReporter = function () {
    var analytics = (0, context_1.useAnalytics)();
    var sessionId = (0, app_utils_1.useConstant)(function () { return (0, nanoid_1.nanoid)(); });
    React.useEffect(function () {
        analytics === null || analytics === void 0 ? void 0 : analytics.setProperties({ session_id: sessionId });
        analytics === null || analytics === void 0 ? void 0 : analytics.track('Session start');
        var onBeforeUnload = function () {
            analytics === null || analytics === void 0 ? void 0 : analytics.track('Session end');
        };
        window.addEventListener('beforeunload', onBeforeUnload);
        return function () {
            window.removeEventListener('beforeunload', onBeforeUnload);
        };
    }, [analytics]);
    return null;
};
exports.AnalyticsSessionReporter = AnalyticsSessionReporter;
//# sourceMappingURL=session_reporter.js.map